module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/44.009fbc4d.png";